import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';
import { Start } from './features/start/Start';
import { Login } from './features/auth/Login';
import { LoginCode } from './features/auth/LoginCode';
import { LoginTotp } from './features/auth/LoginTotp';
import { LoginChallenge } from './features/auth/LoginChallenge';
import { AuthCallback } from './features/auth/AuthCallback';
import { DeskPicker } from './features/desk/DeskPicker';
import { Details } from './features/details/Details';
import { Payment } from './features/payment/Payment';
import { Done } from './features/done/Done';
import { Membership } from './features/membership/Membership';
import { RequireSession } from './features/auth/RequireSession';
import { RouteError } from './features/shell/RouteError';

/**
 * Member funnel (09-web-member § 2).
 *
 * D-005: purchase funnel **only**. Everything a member does afterwards lives in
 * the mobile app; `/mitglied` is the one exception, so a web buyer has somewhere
 * to land after paying.
 */
const pages: RouteObject[] = [
  { path: '/', element: <Navigate to="/start" replace /> },
  { path: '/start', element: <Start /> },
  { path: '/login', element: <Login /> },
  { path: '/login/code', element: <LoginCode /> },
  { path: '/login/totp', element: <LoginTotp /> },
  { path: '/login/challenge', element: <LoginChallenge /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    element: <RequireSession />,
    children: [
      { path: '/platz', element: <DeskPicker /> },
      { path: '/angaben', element: <Details /> },
      { path: '/zahlung', element: <Payment /> },
      { path: '/fertig', element: <Done /> },
      { path: '/mitglied', element: <Membership /> },
    ],
  },
];

/** 04 § 15 — one root error boundary over every page (03 § 4.14 `genericError`). */
export const routes: RouteObject[] = [{ errorElement: <RouteError />, children: pages }];
